module.exports = __webpack_public_path__ + "img/4.af2db6ae.png";